import { tv } from '~/utils/tv'

export const CardInformativeDescriptionVariants = tv({
  base: `
      text-text-neutral font-rdmodern font-regular text-threeandhalfpulse line-clamp-4
  `,
  variants: {},
})
